export const CLEAN_REDUCER = 'CLEAN_REDUCER';
export const SHARED_DEVICES_EXTERNAL = 'SHARED_DEVICES_EXTERNAL';
export const SELECTED_TRAIL = 'SELECTED_TRAIL';
